import { render, staticRenderFns } from "./todo-list-item.vue?vue&type=template&id=fc97edbe&"
import script from "./todo-list-item.vue?vue&type=script&lang=js&"
export * from "./todo-list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports